import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@material-ui/core/Badge';

export default class BadgeWithTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            label: this.props.label !== undefined ? this.props.label : '',
            message: this.props.message ? this.props.message : '',
            icon: this.props.icon ? this.props.icon: '',
            onclick: this.props.onclick ? this.props.onclick:'',
            link: this.props.link ? this.props.link:'',
            id:this.props.id ? this.props.id:'',
            size:this.props.size ? this.props.size:'default',
            open:false,
            class:this.props.class ? this.props.class:'',
        };

        this.handleTooltipClose = this.handleTooltipClose.bind(this);
        this.handleTooltipOpen = this.handleTooltipOpen.bind(this);

    }
    setIcon(){
        if(this.state.icon){
            return (<i className={this.state.icon}></i>);
        }else{
            return "";
        }
    }
    handleTooltipClose(){
        if(this.state.open == true){
            this.setState({open:false});
        }
    };
    
    handleTooltipOpen(){
        if(this.state.open == false){
            this.setState({open:true});
        }
    };
    componentDidUpdate(prevProps) {
        if(JSON.stringify(this.props) === JSON.stringify(prevProps))
            return;
            
        this.setState({ label: this.props.label,link: this.props.link,onclick:this.props.onclick });
    }    
    render() {
        
        return (
            <>
                {/* <Tooltip onClose={this.handleTooltipClose} onOpen={this.handleTooltipOpen} open={this.state.open} title={this.props.message}> */}
                    <Badge href={this.state.link} className={"badge badge-warning badge-pill " + this.state.class} size={this.state.size}>{this.setIcon()}{this.state.label}</Badge>
                {/* </Tooltip>              */}
            </>
        );
    }
}
